import { AUTH_SUCCESS_EVENT, AuthSuccessEventDetail } from '../types';

/**
 * Dispatches the `benzinga:auth:success` window event. SSR-safe.
 * Contract — do not change `detail` shape without coordinating with Optimizely / GA / internal consumers.
 */
export const emitAuthSuccess = (detail: AuthSuccessEventDetail): void => {
  if (typeof window === 'undefined') return;
  try {
    window.dispatchEvent(new CustomEvent<AuthSuccessEventDetail>(AUTH_SUCCESS_EVENT, { detail }));
  } catch {
    // CustomEvent unavailable in some legacy environments — fail silent.
  }
};
